// FIXME: this is defined here as an enum and in pages/RolePlaySummary.vue as a const object
// this is used in files that are TS converted
export enum SummaryState {
    LOADING = "loading",
    LOADED = "loaded",
}
